import { render } from "./ParentWithStudentsForm.vue?vue&type=template&id=e9841e34&scoped=true"
import script from "./ParentWithStudentsForm.vue?vue&type=script&lang=js"
export * from "./ParentWithStudentsForm.vue?vue&type=script&lang=js"

import "./ParentWithStudentsForm.vue?vue&type=style&index=0&id=e9841e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9841e34"]])

export default __exports__